export default {
    /* GET_CUSTOMERS
    ---------------------------------------------------------------
    */
    GET_CUSTOMERS_REQUEST: state => {
        state.customersLoading = true
    },
    GET_CUSTOMERS_SUCCESS: (state, data) => {
        state.customers = data.results
        state.customersLoading = false
    },
    GET_CUSTOMERS_FAILURE: state => {
        state.customersLoading = false
    },
    /* GET_CUSTOMERS_TYPES
    ---------------------------------------------------------------
    */
    GET_CUSTOMERS_TYPES_SUCCESS: (state, data) => {
        state.customerTypes = data
    },
    /* GET_ADDRESS_TYPES_SUCCESS
    ---------------------------------------------------------------
    */
    GET_ADDRESS_TYPES_SUCCESS: (state, data) => {
        state.addressTypes = data
    },
    /* GET_COUNTRIES_SUCCESS
    ---------------------------------------------------------------
    */
    GET_COUNTRIES_SUCCESS: (state, data) => {
        state.countries = data
    },
    /* GET_CUSTOMER_CONTACTS
    ---------------------------------------------------------------
    */
    SET_CUSTOMERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_CUSTOMERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    GET_PRODUCTION_FILE_CUSTOMER_CONFIGURATION_SUCCESS: (state, data) => {
        state.productionFileCustomerConfiguration = data
    }
}